import React from "react";
import GridWrapper from "/app/src/components/generic/gridWrapper";

type BreakdownItem = {
  id: string;
  name?: string;
  fullName?: string;
  currentQuantity: number;
};

interface Props {
  title?: string;
  items: BreakdownItem[];
}

/**
 * BreakdownList — renders an optional title and a responsive grid of breakdown items,
 * showing each item's fullName or name and its current quantity.
 *
 * @param props.title - Optional title shown above the list.
 * @param props.items - Array of BreakdownItem objects to render.
 */
export default function BreakdownList({ title, items }: Props) {
  if (!items || items.length === 0) return null;

  return (
    <div>
      {title && <h3 className="text-[16px] font-medium mb-4">{title}</h3>}
      <GridWrapper responsive={{ sm: 1, md: 3, lg: 4 }}>
        {items.map((it) => (
          <div className="flex flex-col gap-1" key={it.id}>
            <span className="text-black font-medium text-sm">
              {it.fullName || it.name}
            </span>
            <span>{String(it.currentQuantity)}</span>
          </div>
        ))}
      </GridWrapper>
    </div>
  );
}
